'use strict'

import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js'
import { dom, flush } from '@polymer/polymer/lib/legacy/polymer.dom.js' // eslint-disable-line
import { html } from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/paper-card/paper-card'
import '@polymer/paper-input/paper-input'
import '@polymer/iron-icon/iron-icon'
import '@polymer/iron-icons/maps-icons'

Polymer({
  is: 'moskito-address-form',
  _template: html`
  <style include="iron-flex iron-flex-alignment iron-flex-factors paper-material-styles">
  :host {
    display: block;
  }
  paper-card {
    display: flex;
  }
  label {
    font-weight: 700;
  }
  .h-spaced + .h-spaced {
    margin-left: 12px;
  }
  .v-spaced + .v-spaced {
    margin-top: 12px;
  }
  </style>
  <paper-card>
    <div class="card-content vertical layout flex">
      <label><iron-icon icon="maps:place"></iron-icon> {{label}}</label>
      <paper-input id="street_1" value='{{value.street_1}}' label="{{_translate('Street')}}" class="flex " required auto-validate error-message="{{_translate('Required information')}}">
      </paper-input>
      <paper-input id="street_2" value='{{value.street_2}}' label="{{_translate('Street complement')}}" class="flex ">
      </paper-input>
      <div class="horizontal layout flex ">
        <paper-input id="postal_code" value='{{value.postal_code}}' label="{{_translate('Postal Code')}}" class="flex-1 h-spaced" required allowed-pattern="[0-9A-Z-]" auto-validate error-message="{{_translate('Required information')}}">
        </paper-input>
        <paper-input id="city" value='{{value.city}}' label="{{_translate('City')}}" class="flex-2 h-spaced" required auto-validate error-message="{{_translate('Required information')}}">
        </paper-input>
      </div>
      <paper-input id="country" value='{{value.country}}' label="{{_translate('Country')}}" class="flex " required auto-validate error-message="{{_translate('Required information')}}">
      </paper-input>
    </div>
  </paper-card>
  `,
  properties: {
    value: {
      type: Object
    },
    label: {
      type: String,
      value: function () {
        return this._translate('Address')
      }
    }
  },
  validate: function () {
    let out = true
    const inputs = dom(this.root).querySelectorAll('paper-input')
    for (let i = 0; i < inputs.length; i++) {
      out = inputs[i].validate() && out
    }
    return out
  },
  _translate: function (string) {
    return window.__(string)
  }
})
